module.exports = __webpack_public_path__ + "static/media/common.122b5b53.webp";